import Vue from 'vue'
import Vuex from 'vuex'
import appApiStore from './base/appApi'
import keycloakAuthStore from './base/keycloakAuth'
import enterpriseDataApiStore from './base/enterpriseDataApi'
import formStore from './forms'
import applicationStore from './application/application'
import bursaryApplicationStore from './application/bursaryApplication'
import bursaryApplicationAttachmentStore from './application/bursaryApplicationAttachment'
import bursaryApplicationChecklistStore from './application/bursaryApplicationChecklist'
import childcareApplicationStore from './application/childcareApplication'
import childcareApplicationAttachmentStore from './application/childcareApplicationAttachment'
import childcareApplicationChecklistStore from './application/childcareApplicationChecklist'
import housingApplicationStore from './application/housingApplication'
import housingApplicationAttachmentStore from './application/housingApplicationAttachment'
import housingApplicationChecklistStore from './application/housingApplicationChecklist'
import emaApplicationStore from './application/emaApplication'
import emaApplicationAttachmentStore from './application/emaApplicationAttachment'
import emaApplicationChecklistStore from './application/emaApplicationChecklist'
import financialAssistanceApplicationStore from './application/financialAssistanceApplication'
import financialAssistanceApplicationAttachmentStore from './application/financialAssistanceApplicationAttachment'
import financialAssistanceApplicationChecklistStore from './application/financialAssistanceApplicationChecklist'
import addressStore from './address'
import lookupStore from './lookups'
import bursaryStore from './bursary'
import communicationStore from './communications'
import localSettingStore from './localSettings'
import courseStore from './courses'
import objectSettingStore from './objectSettings'
import yearStore from './years'

Vue.use(Vuex)

export default new Vuex.Store({
    
    modules: {
        appApi: appApiStore,
        keycloakAuth: keycloakAuthStore,
        enterpriseDataApi: enterpriseDataApiStore,
        forms: formStore,
        applications: applicationStore,
        bursaryApplications: bursaryApplicationStore,
        bursaryApplicationAttachments: bursaryApplicationAttachmentStore,
        bursaryApplicationChecklists: bursaryApplicationChecklistStore,
        childcareApplications: childcareApplicationStore,
        childcareApplicationAttachments: childcareApplicationAttachmentStore,
        childcareApplicationChecklists: childcareApplicationChecklistStore,
        housingApplications: housingApplicationStore,
        housingApplicationAttachments: housingApplicationAttachmentStore,
        housingApplicationChecklists: housingApplicationChecklistStore,
        emaApplications: emaApplicationStore,
        emaApplicationAttachments: emaApplicationAttachmentStore,
        emaApplicationChecklists: emaApplicationChecklistStore,
        financialAssistanceApplications: financialAssistanceApplicationStore,
        financialAssistanceApplicationAttachments: financialAssistanceApplicationAttachmentStore,
        financialAssistanceApplicationChecklists: financialAssistanceApplicationChecklistStore,
        addresses: addressStore,
        lookups: lookupStore,
        bursaries: bursaryStore,
        communications: communicationStore,
        localSettings: localSettingStore,
        courses: courseStore,
        objectSettings: objectSettingStore,
        years: yearStore,
    }
});
